export enum UserType {
  Student = 'student',
  Parent = 'parent',
}

export interface User {
  id: string;
  email: string | null;
  type: UserType;
  name: string;
  surname: string;
  grade: number;
  lexileId: string;
  profileImage: {
    originalUrl: string;
    compressedUrl: string | null;
    iconUrl: string | null;
  };
  parentId: string | null;
  parent?: User;
  children?: User[];
  createdAt: Date;
}
